import { styled } from "styled-components";

import { colors, Text } from "@vericus/cadmus-ui";

interface ClickableSubcategoryProps {
  isActive?: boolean;
  name: string;
  onClick: VoidFunction;
}

export const ClickableSubcategory = ({
  isActive,
  name,
  onClick,
}: ClickableSubcategoryProps) => {
  return (
    <RibbonButton
      isActive={isActive}
      onClick={onClick}
      title={name}
      aria-current={isActive === true ? "true" : "false"}
    >
      <SubcategoryText isActive={isActive} kind="bodyMd" as="div">
        {name}
      </SubcategoryText>
    </RibbonButton>
  );
};

const RibbonButton = styled.button<{ isActive?: boolean }>`
  border: 0;
  margin: 0;
  background-color: ${(p) =>
    p.isActive === true ? colors.lilac700 : "transparent"};
  width: 100%;
  border-radius: 0 8px 8px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.1s ease-out;
  padding: 12px 24px;
  box-sizing: border-box;

  &:hover {
    background-color: ${(p) =>
      p.isActive === true ? colors.lilac700 : colors.grey50};
  }

  &:focus {
    outline: none;
    ${(p) => p.theme.focusInset};
  }
`;

const SubcategoryText = styled(Text)<{ isActive?: boolean; fontSize?: number }>`
  font-size: 16px;
  font-weight: ${(p) => (p.isActive === true ? 700 : 400)};
  color: ${(p) => (p.isActive === true ? colors.white100 : colors.black200)};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
